import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { useFeatureIsOn } from "@/app/featureFlags";
import { Tab, Tabs } from "@/components/Tabs";
import {
  rudderAnalytics,
  HotelTrackingEvents,
  FlightTrackingEvents,
  TripTrackingEvents,
} from "@/lib/rudderstack";
import type { SearchScope } from "@/types/types";

type CategorySwitcherProps = {
  current: SearchScope;
};

const eventMap = {
  flights: FlightTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  hotels: HotelTrackingEvents.USER_SEARCHED_FOR_ORDERS,
  trips: TripTrackingEvents.USER_SEARCHED_FOR_ORDERS,
} as const;

export const CategorySwitcher = ({ current }: CategorySwitcherProps) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const isTripsFlowEnabled = useFeatureIsOn("trips-flow");

  return (
    <Tabs
      value={current}
      onChange={(newCategory) => {
        if (eventMap[newCategory]) {
          rudderAnalytics.track(eventMap[newCategory]);
        }

        navigate({
          to: "/bookings",
          search: {
            category: newCategory,
          },
          replace: true,
        });
      }}
    >
      <Tab
        value="flights"
        label={intl.formatMessage({
          description: "Navigation label for the Flights section",
          defaultMessage: "Flights",
        })}
      />
      <Tab
        value="hotels"
        label={intl.formatMessage({
          description: "Navigation label for the Hotels section",
          defaultMessage: "Hotels",
        })}
      />
      {isTripsFlowEnabled ? (
        <Tab
          value="trips"
          label={intl.formatMessage({
            description: "Navigation label for the Trips section",
            defaultMessage: "Trips",
          })}
        />
      ) : null}
    </Tabs>
  );
};
